import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import GroupsIcon from "@mui/icons-material/Groups";
import LockIcon from "@mui/icons-material/Lock";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PersonOutline from "@mui/icons-material/PersonOutline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Alert,
  Box,
  Button,
  Card,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Snackbar,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { paths } from "../routes/path";
import EmailPreview from "./email-preview-dialog";
import InternalNotificationsPopup from "./internal-notifications";
import InterviewQuestion from "./interview-question";
import InvitedCandidate from "./invite-candidates";
import PreviewScreen from "./previewDialog";
import PublicLinkPopup from "./public-link-popup";
import SharingSetting from "./sharing-setting-popup";

const AddPosition = () => {
  const { state } = useLocation();
  const position = state?.position;
  const location = useLocation();
  const addPositionId = location.state?.addPositionId || null;
  const fetchPositions = state?.fetchPositions;
  const [thinkingTime, setThinkingTime] = useState("15 Seconds");
  const [answerLength, setAnswerLength] = useState("2 Minutes");
  const [questionRetake, setQuestionRetake] = useState("None");
  const [opened, setOpened] = useState(false);
  const [candidatePage, setCandidatePage] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [jobTitle, setJobTitle] = useState("");
  const [previewDialog, setPreviewDialog] = useState();
  const [questions, setQuestions] = useState([]);
  const [introVideo, setIntroVideo] = useState(null);
  const [farewellVideo, setFarewellVideo] = useState(null);
  const [isPublicEnabled, setIsPublicEnabled] = useState(false);
  const [publicLink, setPublicLink] = useState("");
  const [isShareMember, setIsShareMember] = useState(false);
  const [selectedPreview, setSelectedPreview] = useState(null);
  const [message, setMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [openPublickLink, setOpenPublickLink] = useState(false);
  const [openSharingSetting, setOpenSharingSeting] = useState(false);
  const [createdPositionId, setCreatedPositionId] = useState(null);
  const [positionData, setPositionData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const showSnackbar = (msg, type) => {
    setMessage(msg);
    setSeverity(type);
    setOpen(true);
  };

  const handlePreviewOpen = (item) => {
    setSelectedPreview(item);
  };

  const handlePreviewClose = () => {
    setSelectedPreview(null);
  };

  const [positionId, setPositionId] = useState(
    position?.id || null || addPositionId
  );

  const handlePositionSave = (newPositionId) => {
    setPositionId(newPositionId);
  };

  useEffect(() => {
    if (!positionId) return;

    const fetchQuestions = async () => {
      try {
        const response = await axios.get(
          `https://api.a2ajobs.com/api/questions?position_id=${positionId}`
        );
        setQuestions(response.data.data.questions);
        setIntroVideo(response.data.data.introVideo);
        setFarewellVideo(response.data.data.closeVideo);
        setPublicLink(response.data.data.public_link);
      } catch (error) {
        console.error("Error fetching questions:", error);
      }
    };

    fetchQuestions();
  }, [positionId, addPositionId]);

  useEffect(() => {
    if (addPositionId || createdPositionId || position?.id) {
      fetchPositionData(addPositionId || createdPositionId || position?.id);
    }
  }, [addPositionId]);

  const fetchPositionData = async (positionId) => {
    try {
      const response = await axios.get(
        `https://api.a2ajobs.com/api/get-position/${position?.id || addPositionId || createdPositionId
        }`
      );
      setPositionData(response.data.data);
    } catch (error) {
      console.error("❌ Error fetching position data:", error);
    }
  };
  const handleSaveQuestions = (count) => {
    setOpened(false);
  };
  const handleSubmit = async () => {
    setSubmitting(true);

    const formData = new FormData();
    formData.append("title", jobTitle);
    formData.append("tags[0]", "adsdsd");
    formData.append("share_with_all_team_members", isShareMember ? 1 : 0);
    formData.append("public_link", "asdsds");
    formData.append("public_link_enabled", isPublicEnabled ? 1 : 0);
    formData.append("candidate_thinking_time", thinkingTime);
    formData.append("candidate_max_answer_length", answerLength);
    formData.append("branding_color_and_logo", "dasds");
    formData.append("question_retakes", questionRetake);

    try {
      let response;
      if (position?.id || addPositionId || createdPositionId) {
        const positionId = position?.id || addPositionId || createdPositionId;
        formData.append("position_id", positionId);

        response = await axios.post(
          "https://api.a2ajobs.com/api/position-update",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response?.data?.status === "success") {
          showSnackbar("Position has been updated successfully!", "success");
          window.location.reload(true);
        } else {
          console.error("Invalid response data:", response);
        }
      } else {
        response = await axios.post(
          "https://api.a2ajobs.com/api/position-create",
          formData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (response?.data?.status === "success") {
          setCreatedPositionId(response?.data?.data.position_id);
          showSnackbar("Position has been added successfully!", "success");
          navigate(paths.PositionListPage);
        } else {
          console.error("Invalid response data:", response);
        }
      }

      // await fetchPositions();

      // setTimeout(() => {
      //   navigate(paths.PositionListPage);
      // }, 1000);
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const [notifications, setNotifications] = useState([]);

  const addNotification = () => {
    setNotifications([
      ...notifications,
      {
        id: Date.now(),
        step: 1,
        type: "",
        language: "EN",
        event: "",
        trigger: "",
        isLive: false,
      },
    ]);
  };
  const fetchNotifications = async (positionId) => {
    if (!positionId) return;

    try {
      const response = await axios.get(
        `https://api.a2ajobs.com/api/get_message_setting/${positionId || addPositionId
        }`
      );
      const fetchedNotifications = response.data.data.map((item) => ({
        ...item,
        step: item.trigger ? 3 : item.event ? 2 : item.type ? 1 : 0,
        isLive: true,
      }));
      setNotifications(fetchedNotifications);
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  const updateNotification = async (id, field, value) => {
    // Update the state first
    const updatedNotifications = notifications.map((item) =>
      item.id === id ? { ...item, [field]: value } : item
    );

    setNotifications(updatedNotifications);

    // Find the updated notification from the updated array
    const updatedNotification = updatedNotifications.find((item) => item.id === id);
    if (!updatedNotification) return;

    // Check if all required fields are filled
    const isComplete = updatedNotification.type &&
      updatedNotification.event &&
      updatedNotification.trigger;

    if (isComplete) {
      const existingPositionId = position?.id || addPositionId || createdPositionId;

      // Create the payload with the current values
      const payload = {
        id: updatedNotification.isLive ? updatedNotification.id : null,
        type: updatedNotification.type,
        event: updatedNotification.event,
        trigger: updatedNotification.trigger,
        position_id: existingPositionId,
      };

      if (!existingPositionId) {
        // Create position first if it doesn't exist
        try {
          const createResponse = await axios.post(
            "https://api.a2ajobs.com/api/position-create",
            {
              title: jobTitle || "Write The Job Title Here",
              public_link_enabled: isPublicEnabled ? 1 : 0,
            }
          );

          const newPositionId = createResponse.data?.data?.position_id;
          if (newPositionId) {
            setCreatedPositionId(newPositionId);
            payload.position_id = newPositionId;

            // Capture the response from the store_message_setting API call
            const storeResponse = await axios.post(
              "https://api.a2ajobs.com/api/store_message_setting",
              payload
            );

            // Update the notification with the ID from response if it's a new record
            if (!updatedNotification.isLive && storeResponse.data.data?.id) {
              setNotifications((prev) =>
                prev.map((item) =>
                  item.id === id
                    ? { ...item, id: storeResponse.data.data.id, isLive: true }
                    : item
                )
              );
            }

            showSnackbar("Notification saved successfully!", "success");
          }
        } catch (error) {
          console.error("Error creating position:", error);
        }
      } else {
        try {
          // Capture the response from the store_message_setting API call
          const response = await axios.post(
            "https://api.a2ajobs.com/api/store_message_setting",
            payload
          );

          // Update the notification with the ID from response if it's a new record
          if (!updatedNotification.isLive && response.data.data?.id) {
            setNotifications((prev) =>
              prev.map((item) =>
                item.id === id
                  ? { ...item, id: response.data.data.id, isLive: true }
                  : item
              )
            );
          }

          showSnackbar("Notification saved successfully!", "success");
        } catch (error) {
          console.error("Error storing message:", error);
          showSnackbar("Error saving notification", "error");
        }
      }
    }
  };

  const storeNotification = async (positionId, notificationId) => {
    const notification = notifications.find(item => item.id === notificationId);

    const payload = {
      id: notification.isLive ? notification.id : null, // Send null for new records, actual ID for existing
      type: notification.type,
      event: notification.event,
      trigger: notification.trigger,
      position_id: positionId,
    };

    try {
      const response = await axios.post(
        "https://api.a2ajobs.com/api/store_message_setting",
        payload
      );

      // Update the notification with the ID from response if it's a new record
      if (!notification.isLive && response.data.data?.id) {
        setNotifications((prev) =>
          prev.map((item) =>
            item.id === notificationId
              ? { ...item, id: response.data.data.id, isLive: true }
              : item
          )
        );
      }

      showSnackbar("Notification saved successfully!", "success");
    } catch (error) {
      console.error("Error storing message:", error);
      showSnackbar("Error saving notification", "error");
    }
  };

  const deleteNotification = async (id) => {
    try {
      const response = await axios.delete(
        `https://api.a2ajobs.com/api/delete_message_setting/${id}`
      );

      if (response.status === 200) {
        setNotifications((prev) => prev.filter((item) => item.id !== id));
        showSnackbar("store message has been deleted successfully!", "success");
      } else {
        console.error("Failed to delete notification.");
      }
    } catch (error) {
      console.error("Error deleting notification:", error);
    }
  };

  const deleteLocalNotification = (id) => {
    setNotifications((prev) => prev.filter((item) => item.id !== id));
    showSnackbar("Message has been deleted successfully!", "success");
  };

  useEffect(() => {
    if (position || addPositionId || positionData) {
      setJobTitle(positionData?.title || "");
      setThinkingTime(positionData?.candidate_thinking_time || "15 Seconds");
      setAnswerLength(positionData?.candidate_max_answer_length || "2 Minutes");
      setQuestionRetake(positionData?.question_retakes || "None");
      fetchNotifications(positionData?.id || addPositionId);
    }
  }, [positionData, position?.id, addPositionId]);

  return (
    <>
      <Box sx={{ p: { md: 5, xs: 1 }, mx: { md: 0, xs: 0, lg: 10 } }}>
        <Stack direction="row" justifyContent="center" alignItems="center">
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIcon />
          </IconButton>
          <TextField
            fullWidth
            variant="outlined"
            placeholder="(Write the job title here)"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            sx={{
              ml: 2,
              "& .MuiOutlinedInput-root": {
                fontSize: "28px",
                fontWeight: "bold",
                textAlign: "center",
                border: "none",
                "& fieldset": { border: "none" },
                "&:hover fieldset": { border: "1px solid black" },
                "&.Mui-focused fieldset": { border: "1px solid black" },
              },
              "& input::placeholder": {
                fontSize: { md: "35px", xs: "20px" },
                fontWeight: "bold",
                color: "black",
              },
            }}
          />
        </Stack>
        <Button
          variant="outlined"
          onClick={() => setOpenSharingSeting(true)}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: "grey",
            my: 2,
            ml: { md: 5, xs: 0 },
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "lightgrey",
            },
          }}
        >
          <GroupsIcon />
          All Team
        </Button>

        <Button
          variant="outlined"
          onClick={() => setOpenPublickLink(true)}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: "grey",
            my: 2,
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "lightgrey",
            },
          }}
        >
          <LockIcon />
          Publick Link: {isPublicEnabled ? "Activated" : "Disabled"}
        </Button>
        <Button
          variant="outlined"
          onClick={() => setOpenPopup(true)}
          sx={{
            textTransform: "none",
            borderRadius: "8px",
            color: "grey",
            border: "1px solid transparent",
            "&:hover": {
              borderColor: "lightgrey",
            },
          }}
        >
          <NotificationsNoneIcon />
          Internal Notifications
        </Button>

        <Stack gap={2} mt={2}>
          <Card sx={{ p: 3, mx: { md: 5, xs: 0 } }}>
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={7}>
                <Stack
                  direction={{ md: "row", xs: "column" }}
                  alignItems="center"
                  spacing={3}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "2px dashed #ccc",
                      padding: 3,
                      borderRadius: 2,
                      height: 200,
                      width: { md: "40%", xs: "80%" },
                      textAlign: "center",
                      bgcolor: "#F8F9FA",
                      transition: "all 0.3s ease-in-out",
                      "&:hover": {
                        border: "2px dashed blue",
                        bgcolor: "#E3F2FD",
                        cursor: "pointer",
                        "& .icon, & .text": {
                          color: "blue",
                        },
                      },
                    }}
                  >
                    {introVideo ? (
                      <Box
                        sx={{
                          position: "relative",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        <video
                          src={introVideo}
                          style={{ width: "100%", height: "100%" }}
                          controls
                        />
                      </Box>
                    ) : (
                      <>
                        <IconButton className="icon">
                          <PersonOutline sx={{ fontSize: 40, color: "gray" }} />
                        </IconButton>
                      </>
                    )}
                  </Box>

                  <Box>
                    <Typography variant="h4" fontWeight={600}>
                      Video Interview
                    </Typography>
                    {questions?.length > 0 ? (
                      <>
                        <Typography fontSize={15} color="text.secondary">
                          with {questions?.length} Questions
                        </Typography>
                        <Stack direction="row" spacing={2} mt={2}>
                          <Button
                            variant="contained"
                            sx={{
                              background: "#e0e0e0",
                              color: "#404040",
                              textTransform: "none",
                              borderRadius: "50px",
                            }}
                            onClick={() => setOpened(true)}
                          >
                            Edit
                          </Button>
                          <Button
                            variant="contained"
                            sx={{
                              background: "#e0e0e0",
                              color: "#404040",
                              textTransform: "none",
                              borderRadius: "50px",
                            }}
                            onClick={() => setPreviewDialog(true)}
                          >
                            Preview
                          </Button>
                        </Stack>
                      </>
                    ) : (
                      <>
                        <Typography fontSize={18} color="text.secondary">
                          Upload or record your video interview
                        </Typography>
                        <Button
                          variant="contained"
                          sx={{
                            mt: 2,
                            textTransform: "none",
                            borderRadius: "50px",
                            bgcolor: "#1666EB",
                            p: 2,
                          }}
                          onClick={() => setOpened(true)}
                        >
                          Create Video Interview
                        </Button>
                      </>
                    )}
                  </Box>
                </Stack>
              </Grid>

              <Grid item xs={12} md={5}>
                <Stack spacing={2}>
                  <Stack
                    direction={{ md: "row", xs: "column" }}
                    alignItems={{ md: "center", xs: "start" }}
                    justifyContent="space-between"
                  >
                    <Typography fontWeight={500} fontSize={16} mr={2}>
                      Candidate Thinking Time
                    </Typography>
                    <Select
                      value={thinkingTime}
                      onChange={(e) => setThinkingTime(e.target.value)}
                      sx={{ minWidth: { md: 200, xs: 250 } }}
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value="15 Seconds">15 Seconds</MenuItem>
                      <MenuItem value="1 minute">1 minute</MenuItem>
                      <MenuItem value="Unlimited">Unlimited</MenuItem>
                    </Select>
                  </Stack>

                  <Stack
                    direction={{ md: "row", xs: "column" }}
                    alignItems={{ md: "center", xs: "start" }}
                    justifyContent="space-between"
                  >
                    <Typography fontWeight={500} fontSize={16}>
                      Candidate Max Answer Length
                    </Typography>
                    <Select
                      value={answerLength}
                      onChange={(e) => setAnswerLength(e.target.value)}
                      sx={{ minWidth: { md: 200, xs: 250 } }}
                    >
                      <MenuItem value="1 Minute">1 Minute</MenuItem>
                      <MenuItem value="2 Minutes">2 Minutes</MenuItem>
                      <MenuItem value="3 Minutes">3 Minutes</MenuItem>
                    </Select>
                  </Stack>
                  <Stack
                    direction={{ md: "row", xs: "column" }}
                    alignItems={{ md: "center", xs: "start" }}
                    justifyContent="space-between"
                  >
                    <Typography fontWeight={500} fontSize={16}>
                      Question Retake
                    </Typography>
                    <Select
                      value={questionRetake}
                      onChange={(e) => setQuestionRetake(e.target.value)}
                      sx={{ minWidth: { md: 200, xs: 250 } }}
                    >
                      <MenuItem value="None">None</MenuItem>
                      <MenuItem value="1 Retake">1 Retake</MenuItem>
                      <MenuItem value="2 Retake">2 Retake</MenuItem>
                      <MenuItem value="3 Retake">3 Retake</MenuItem>
                      <MenuItem value="Unlimited">Unlimited</MenuItem>
                    </Select>
                  </Stack>
                </Stack>
              </Grid>
            </Grid>
          </Card>
          <Card sx={{ p: 3, mx: { md: 5, xs: 0 } }}>
            <Box mt={3}>
              <Typography variant="h5">Candidate Notifications</Typography>
              <Typography variant="body2" color="text.secondary" mt={1}>
                Automatically notify candidates by email and/or SMS when
                inviting them.
              </Typography>
              <Button
                variant="contained"
                sx={{
                  background: "#e0e0e0",
                  color: "#404040",
                  textTransform: "none",
                  borderRadius: "6px",
                  mt: 1,
                }}
                onClick={() => navigate("/emailList", { state: { position } })}
              >
                Edit Templates
              </Button>
              <Box mt={2}>
                {notifications?.map((item) => {
                  return (
                    <Stack
                      key={item.id}
                      direction="row"
                      alignItems="center"
                      justifyContent={"space-between"}
                      gap={1}
                      sx={{
                        mb: 2,
                        p: 1,
                        borderRadius: 2,
                        background: "white",
                      }}
                    >
                      <Stack
                        direction={{ md: "row", xs: "column" }}
                        gap={1}
                        alignItems="center"
                      >
                        <Typography sx={{ fontWeight: "bold" }}>Send</Typography>

                        {/* Type Dropdown */}
                        <FormControl sx={{ minWidth: 200 }} size="small">
                          <Select
                            value={item?.type || ""}
                            onChange={(e) =>
                              updateNotification(item.id, "type", e.target.value)
                            }
                            displayEmpty
                          >
                            {!item?.type && (
                              <MenuItem value="" disabled>
                                Email, SMS or WhatsApp
                              </MenuItem>
                            )}
                            <MenuItem value="Email">Email</MenuItem>
                            <MenuItem value="SMS">SMS</MenuItem>
                            <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                          </Select>
                        </FormControl>

                        {/* Event Dropdown */}
                        <FormControl sx={{ minWidth: 200 }} size="small">
                          <Select
                            value={item?.event || ""}
                            onChange={(e) =>
                              updateNotification(item.id, "event", e.target.value)
                            }
                            displayEmpty
                          >
                            {!item?.event && (
                              <MenuItem value="" disabled>
                                What template?
                              </MenuItem>
                            )}
                            <MenuItem value="Invitation">Invitation</MenuItem>
                            <MenuItem value="Reminder">Reminder</MenuItem>
                            <MenuItem value="Interview Completed">
                              Interview Completed
                            </MenuItem>
                          </Select>
                        </FormControl>

                        {/* Trigger Dropdown */}
                        <FormControl sx={{ minWidth: 200 }} size="small">
                          <Select
                            value={item?.trigger || ""}
                            onChange={(e) =>
                              updateNotification(item.id, "trigger", e.target.value)
                            }
                            displayEmpty
                          >
                            {!item?.trigger && (
                              <MenuItem value="" disabled>
                                When?
                              </MenuItem>
                            )}
                            <MenuItem value="On Invitation">On Invitation</MenuItem>
                            <MenuItem value="If no response in 4 hours">
                              If no response in 4 hours
                            </MenuItem>
                            <MenuItem value="If no response in 48 hours">
                              If no response in 48 hours
                            </MenuItem>
                            <MenuItem value="On interview completion">
                              On interview completion
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Stack>

                      <Stack direction="row">
                        <IconButton
                          size="small"
                          onClick={() => handlePreviewOpen(item)}
                        >
                          <RemoveRedEyeIcon />
                        </IconButton>
                        <IconButton
                          size="small"
                          color="error"
                          onClick={() => {
                            item.isLive
                              ? deleteNotification(item.id)
                              : deleteLocalNotification(item.id);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Stack>
                    </Stack>
                  );
                })}

                <Button
                  onClick={addNotification}
                  variant="contained"
                  sx={{
                    background: "#e0e0e0",
                    color: "#404040",
                    textTransform: "none",
                    borderRadius: "6px",
                    mt: 1,
                  }}
                >
                  + Add Message
                </Button>
              </Box>
            </Box>
          </Card>
        </Stack>
        <Box
          display="flex"
          justifyContent="space-between"
          mt={3}
          mx={{ md: 5, xs: 1 }}
        >
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={submitting}
            sx={{ textTransform: "none", bgcolor: "#1666EB" }}
          >
            {position ? "Update" : "Save"}
          </Button>

          <Button
            variant="contained"
            disabled={!positionId}
            sx={{
              background: "#e0e0e0",
              color: "#404040",
              textTransform: "none",
              borderRadius: "6px",
            }}
            onClick={() => setCandidatePage(true)}
          >
            Invite Candidates
          </Button>
        </Box>
      </Box>
      <InterviewQuestion
        jobTitle={jobTitle}
        thinkingTime={thinkingTime}
        answerLength={answerLength}
        questionRetake={questionRetake}
        open={opened}
        onClose={() => setOpened(false)}
        position={position}
        onSave={handleSaveQuestions}
        question={questions}
        onSavePosition={handlePositionSave}
        setCandidatePage={setCandidatePage}
        introVideo={introVideo}
        createdPositionId={createdPositionId}
        isPublicEnabled={isPublicEnabled}
        farewellVideo={farewellVideo}
        sharedJobTitle={jobTitle}
      />
      <InvitedCandidate
        open={candidatePage}
        onClose={() => setCandidatePage(false)}
        position={position}
        positionId={positionId || createdPositionId} // Use createdPositionId as fallback
        // Only pass positionId if it's available
        shouldFetchCandidates={!!(positionId || createdPositionId)}
      />
      <InternalNotificationsPopup
        open={openPopup}
        onClose={() => setOpenPopup(false)}
        positionId={position?.id}
      />
      <PublicLinkPopup
        open={openPublickLink}
        onClose={() => setOpenPublickLink(false)}
        position={position}
        isPublicEnabled={isPublicEnabled}
        setIsPublicEnabled={setIsPublicEnabled}
        publicLink={publicLink}
        positionId={positionId}
      />
      <SharingSetting
        open={openSharingSetting}
        onClose={() => setOpenSharingSeting(false)}
        position={position}
        isShareMember={isShareMember}
        setIsShareMember={setIsShareMember}
      />
      <PreviewScreen
        open={previewDialog}
        onClose={() => setPreviewDialog(false)}
        position={positionData || position} // Use positionData if available, fallback to position
        jobTitle={jobTitle}
        questions={questions}
      />
      {selectedPreview && (
        <EmailPreview
          open
          onClose={handlePreviewClose}
          selectedPreview={selectedPreview}
          questions={questions}
          jobTitle={jobTitle}
        />
      )}
      <Snackbar
        open={open}
        autoHideDuration={3000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity={severity}
          variant="filled"
        >
          {message}
        </Alert>
      </Snackbar>
    </>
  );
};
export { AddPosition };